import { Link } from 'react-router-dom'
import { PolicyPageWrapper } from './PolicyPageWrapper'
import PageTitle from '../../components/common/PageTitle'
import SeoHelmet from '../../components/common/SeoHelmet'

const TermsAndConditionsPage = () => (
  <>
    <SeoHelmet
      title="Terms and Conditions"
      description="Read Sokooni's terms and conditions for using our marketplace platform. Understand your rights and responsibilities as a user."
      keywords="terms and conditions, user agreement, marketplace terms, legal terms, Sokooni terms"
      url="/terms"
    />
    <PolicyPageWrapper title="Terms and Conditions">
      <p>
        Welcome to Sokooni! By using our website or mobile app, you agree to the following Terms and
        Conditions. Please read them carefully.
      </p>

      <h2 className="text-2xl font-semibold mt-4">1. Who We Are</h2>
      <p>
        Sokooni is a Kenyan online marketplace that connects buyers and sellers. We provide the
        platform, but we are not the seller of the items listed unless explicitly stated.
      </p>

      <h2 className="text-2xl font-semibold mt-4">2. Account Registration</h2>
      <ul className="list-disc list-inside mb-6">
        <li>You must be at least 18 years old to create an account.</li>
        <li>You are responsible for maintaining the confidentiality of your account details.</li>
        <li>You agree to provide accurate, up-to-date information when registering.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-4">3. Buying on Sokooni</h2>
      <ul className="list-disc list-inside mb-6">
        <li>When you place an order, you’re entering into a contract directly with the seller.</li>
        <li>Product descriptions, prices, and availability are provided by sellers.</li>
        <li>
          Sokooni is not responsible for inaccuracies, delays, or problems caused by individual
          sellers.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-4">4. Selling on Sokooni</h2>
      <ul className="list-disc list-inside mb-6">
        <li>Sellers must provide truthful and accurate listings.</li>
        <li>
          Each seller is responsible for managing their orders, shipping, returns, and refunds.
        </li>
        <li>Sellers must comply with all applicable Kenyan laws and Sokooni policies.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-4">5. Payments</h2>
      <ul className="list-disc list-inside mb-6">
        <li>All transactions are processed securely through our payment partners.</li>
        <li>Sokooni may withhold payments in case of disputes or policy violations.</li>
        <li>Prices are listed in Kenyan Shillings (KES) unless stated otherwise.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-4">6. Returns &amp; Refunds</h2>
      <p>
        Each product has its own return policy defined by the seller. If no return policy is listed,
        the default is no returns, unless the item is defective or incorrect. Sokooni may assist in
        resolving disputes, but we do not guarantee refunds. For more information, please review our{' '}
        <Link to="/return-policy" className="text-blue-600 hover:underline">
          Return Policy
        </Link>
        .
      </p>

      <h2 className="text-2xl font-semibold mt-4">7. Prohibited Activities</h2>
      <ul className="list-disc list-inside mb-6">
        <li>Post false, misleading, or offensive content.</li>
        <li>Sell counterfeit, illegal, or restricted items.</li>
        <li>Attempt to hack, damage, or interfere with the platform.</li>
        <li>Spam users or use Sokooni for fraudulent activity.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-4">8. Intellectual Property</h2>
      <p>
        All content on Sokooni (logos, images, software, etc.) belongs to Sokooni or its licensors.
        You may not copy, distribute, or use our content without permission.
      </p>

      <h2 className="text-2xl font-semibold mt-4">9. Limitation of Liability</h2>
      <ul className="list-disc list-inside mb-6">
        <li>
          Sokooni is not liable for any direct or indirect loss arising from use of the platform.
        </li>
        <li>We do not guarantee that the site will always be available or error-free.</li>
        <li>Sellers are solely responsible for their products and transactions.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-4">10. Privacy</h2>
      <p>
        We respect your privacy. Please read our{' '}
        <Link to="/privacy-policy" className="text-blue-600 hover:underline">
          Privacy Policy
        </Link>{' '}
        to understand how we collect and use your data.
      </p>

      <h2 className="text-2xl font-semibold mt-4">11. Changes to These Terms</h2>
      <p>
        We may update these Terms from time to time. Continued use of the platform means you accept
        the new Terms.
      </p>

      <h2 className="text-2xl font-semibold mt-4">12. Governing Law</h2>
      <p>
        These Terms are governed by the laws of Kenya. Any disputes shall be handled in Kenyan
        courts.
      </p>

      <h2 className="text-2xl font-semibold mt-4">13. Contact Us</h2>
      <p>
        For questions or concerns, contact us at:
        <br />
        <strong>Email:</strong>{' '}
        <a href="mailto:support@sokooni.com" className="text-blue-600 hover:underline">
          support@sokooni.com
        </a>
        <br />
        <strong>Address:</strong> Sokooni Ltd., P.O. Box 12345, Nairobi, Kenya
      </p>
    </PolicyPageWrapper>
  </>
)

export default TermsAndConditionsPage
